import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* Reserves the scrollbar's space so pages whose height changes do not shift sideways. */
  html {
    scrollbar-gutter: stable;
  }

  body {
    margin: 0;
    font-family: Ubuntu, system-ui, -apple-system, sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;
